export default function ServiceState({ error, retry, empty }: { error?: string | null; retry: () => Promise<void>; empty: string }) {
  return <div className="service-state" role={error ? 'alert' : 'status'}>
    <div><strong>{error ? 'Connection needs attention' : empty}</strong>
      <p>{error || 'There are no published entries to show right now. Check back later or explore our practical software guides.'}</p></div>
    <div className="service-state-actions"><button className="btn btn-secondary" onClick={() => { void retry(); }}>Try again</button><a className="text-link" href="https://gptmarketplus.com/guides">Explore guides ↗</a></div>
  </div>;
}
